import { render, staticRenderFns } from "./ClassroomIndex.vue?vue&type=template&id=f7ccd4cc"
import script from "./ClassroomIndex.vue?vue&type=script&lang=js"
export * from "./ClassroomIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports